__turbopack_context__.v({
  "assignedVehicleModal": "_7WNozG_assignedVehicleModal",
  "assignedVehicleModalContent": "_7WNozG_assignedVehicleModalContent",
  "assignedVehicleModalContentDetails": "_7WNozG_assignedVehicleModalContentDetails",
  "assignedVehicleModalContentDetailsColum": "_7WNozG_assignedVehicleModalContentDetailsColum",
  "assignedVehicleModalContentDetailsItem": "_7WNozG_assignedVehicleModalContentDetailsItem",
  "assignedVehicleModalContentDetailsItemLabel": "_7WNozG_assignedVehicleModalContentDetailsItemLabel",
  "assignedVehicleModalContentWrapper": "_7WNozG_assignedVehicleModalContentWrapper",
  "assignedVehicleModalFooter": "_7WNozG_assignedVehicleModalFooter",
  "assignedVehicleModalFooterButton": "_7WNozG_assignedVehicleModalFooterButton",
  "assignedVehicleModalFooterButtonFull": "_7WNozG_assignedVehicleModalFooterButtonFull",
  "assignedVehicleModalFooterButtons": "_7WNozG_assignedVehicleModalFooterButtons",
  "conflictDescription": "_7WNozG_conflictDescription",
  "conflictHeader": "_7WNozG_conflictHeader",
  "overlapAssignedVehicle": "_7WNozG_overlapAssignedVehicle",
});
